import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			rootProduct: {
				background: theme.palette.common.white,
				margin: "10px 0px",
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				borderRadius: 6
			},
			images: {
				padding: 16,
				zIndex: 2,
				background: theme.palette.common.white,
				borderRadius: 6,
				"& > img": {
					objectFit: "contain"
				}
			},
			infoProduct: {
				padding: "16px 16px 5px 5px",
				height: 50,
				display: "flex",
				flexDirection: "column",
				justifyContent: "space-between"
			},
			nameProduct: {
				background: "red",
				marginRight: 5,
				padding: 10,
				fontSize: 14,
				height: 18,
				animation: "$moveBackground 1.5s linear infinite"
			},
			"@keyframes moveBackground": {
				"0%": {
					backgroundPosition: "0% 0",
					background: "#fff",
					opacity: 0.5
				},
				"50%": {
					opacity: 1
				},
				"100%": {
					backgroundPosition: "100% 0",
					background: "#f1f1f1",
					opacity: 0.5
				}
			},
			price: {
				color: theme.palette.grey[50],
				fontSize: 12,
				"& > span": {
					color: theme.palette.primary.contrastText,
					fontWeight: 500,
					fontSize: 13
				}
			}
		}),
	{
		name: "ProductItem",
		index: 1
	}
);

export default useStyles;
